module.exports = __webpack_public_path__ + "static/media/img-reel-footer-thadingyut-2025-theme.921b7af3.png";